import React from 'react';


const Footer = () => {
  return (
    <footer>           
      <p>&copy; Shreejan Khya Shrestha</p>
    </footer>
  );
};

export default Footer;
